import base from './base.json';

export default { ...base };
